export default class  IncomeStatementActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_INCOMESTATEMENT='GET_HELPER_INCOMESTATEMENT';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static BEFORE_PRINT_INCOMESTATEMENT='BEFORE_PRINT_INCOMESTATEMENT';
  static PRINT_INCOMESTATEMENT='PRINT_INCOMESTATEMENT';
  static submit(){
    return {
      type:  IncomeStatementActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  IncomeStatementActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  IncomeStatementActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  IncomeStatementActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  IncomeStatementActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  IncomeStatementActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type:  IncomeStatementActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  IncomeStatementActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  IncomeStatementActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  IncomeStatementActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  IncomeStatementActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  IncomeStatementActions.GET_HELPER_INCOMESTATEMENT,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  IncomeStatementActions.ERROR_SERVER,
      payload: error
    };
  }
  static beforePrint(){
    return {
      type: IncomeStatementActions.BEFORE_PRINT_INCOMESTATEMENT,
    };
  }
  static print(printIncomeStatement){
    return {
      type: IncomeStatementActions.PRINT_INCOMESTATEMENT,
      payload: printIncomeStatement
    };
  }
}